import starterIMG from '../assets/images/starter.svg';
import professionalIMG from '../assets/images/professional.svg';
import enterpriseIMG from '../assets/images/enterprise.svg';

const FRONTCARDS = {
  1: {
    Monthly: {
      1: {
        title: 'Starter',
        description: ['Dynamic Digital Signage'],
        priceText: '',
        keyFeatures: 'Key Features:',
        checklistP: [
          'Digital Signage Management',
          'Canva Templates Integration',
          'Trackable QR Codes',
          'Industry-Specific Design Templates',
          'Customized Scheduling & Playlisting',
          'Background Audio',
          'Data Insights & Analytics',
        ],
        buttonLabel: 'Get started',
        icon: starterIMG,
      },
      3: {
        title: 'Professional',
        description: ['Dynamic Digital Signage + Entertainment'],
        priceText: '',
        keyFeatures: 'Everything in Starter, plus:',
        checklistP: [
          '500+ Entertainment Channels',
          'Premium Sports, Viral Videos, News, Health & Wellness and Much More',
          'Interactive Community Wall',
          'Interactive Trivia, Gaming and Sports Betting Odds',
        ],
        buttonLabel: 'Get started',
        icon: professionalIMG,
      },
      4: {
        title: 'Branded Digital Network',
        description: [
          'Dynamic Digital Signage + Premium Entertainment + Custom Branded Elements.',
          'Recommended for 25+ Locations.',
        ],
        priceText: 'Get a Quote',
        keyFeatures: 'Everything in Professional, plus:',
        checklistP: [
          'Tailored & Branded Solutions',
          'Managed & Creative Services',
          'Personalized Implementation',
          'Custom Data Integrations',
          'Custom Support',
        ],
        buttonLabel: 'Book a demo',
        disable: true,
        icon: enterpriseIMG,
        headerStyle: 'card-header-enterprise',
        priceStyle: 'card-price-enterprise',
      },
    },
  },
  '2-9': {
    Monthly: {
      1: {
        title: 'Starter',
        description: ['Dynamic Digital Signage'],
        priceText: '',
        keyFeatures: 'Key Features:',
        checklistP: [
          'Digital Signage Management',
          'Canva Templates Integration',
          'Trackable QR Codes',
          'Industry-Specific Design Templates',
          'Customized Scheduling & Playlisting',
          'Background Audio',
          'Data Insights & Analytics',
        ],
        buttonLabel: 'Book a demo',
        icon: starterIMG,
      },
      3: {
        title: 'Professional',
        description: ['Dynamic Digital Signage + Premium Entertainment'],
        priceText: '',
        keyFeatures: 'Everything in Starter, plus:',
        checklistP: [
          '500+ Entertainment Channels',
          'Premium Sports, Viral Videos, News, Health & Wellness and Much More',
          'Interactive Social Media Wall',
          'Interactive Gaming, including Trivia and Sportsbooks',
        ],
        buttonLabel: 'Book a demo',
        icon: professionalIMG,
      },
      4: {
        title: 'Branded Digital Network',
        description: [
          'Dynamic Digital Signage + Premium Entertainment + Custom Branded Elements.',
          'Recommended for 25+ Locations.',
        ],
        priceText: 'Get a Quote',
        keyFeatures: 'Everything in Professional, plus:',
        checklistP: [
          'Tailored & Branded Solutions',
          'Managed & Creative Services',
          'Personalized Implementation',
          'Custom Data Integrations',
          'Custom Support',
        ],
        buttonLabel: 'Book a demo',
        disable: true,
        icon: enterpriseIMG,
        headerStyle: 'card-header-enterprise',
        priceStyle: 'card-price-enterprise',
      },
    },
  },
  '10-24': {
    Monthly: {
      1: {
        title: 'Starter',
        description: ['Dynamic Digital Signage'],
        priceText: 'Get a Quote',
        keyFeatures: 'Key Features:',
        checklistP: [
          'Digital Signage Management',
          'Canva Templates Integration',
          'Trackable QR Codes',
          'Industry-Specific Design Templates',
          'Customized Scheduling & Playlisting',
          'Background Audio',
          'Data Insights & Analytics',
        ],
        buttonLabel: 'Book a demo',
        icon: starterIMG,
      },
      3: {
        title: 'Professional',
        description: ['Dynamic Digital Signage + Premium Entertainment'],
        priceText: 'Get a Quote',
        keyFeatures: 'Everything in Starter, plus:',
        checklistP: [
          '500+ Entertainment Channels',
          'Premium Sports, Viral Videos, News, Health & Wellness and Much More',
          'Interactive Social Media Wall',
          'Interactive Gaming, including Trivia and Sportsbooks',
        ],
        buttonLabel: 'Book a demo',
        icon: professionalIMG,
      },
      4: {
        title: 'Branded Digital Network',
        description: [
          'Dynamic Digital Signage + Premium Entertainment + Custom Branded Elements.',
          'Recommended for 25+ Locations.',
        ],
        priceText: 'Get a Quote',
        keyFeatures: 'Everything in Professional, plus:',
        checklistP: [
          'Tailored & Branded Solutions',
          'Managed & Creative Services',
          'Personalized Implementation',
          'Custom Data Integrations',
          'Custom Support',
        ],
        buttonLabel: 'Book a demo',
        disable: true,
        icon: enterpriseIMG,
        headerStyle: 'card-header-enterprise',
        priceStyle: 'card-price-enterprise',
      },
    },
  },
  '25+': {
    Monthly: {
      1: {
        title: 'Starter',
        description: ['Dynamic Digital Signage'],
        priceText: 'Get a Quote',
        keyFeatures: 'Key Features:',
        checklistP: [
          'Digital Signage Management',
          'Canva Templates Integration',
          'Trackable QR Codes',
          'Industry-Specific Design Templates',
          'Customized Scheduling & Playlisting',
          'Background Audio',
          'Data Insights & Analytics',
        ],
        buttonLabel: 'Book a demo',
        icon: starterIMG,
        disable: true,
      },
      3: {
        title: 'Professional',
        description: ['Dynamic Digital Signage + Premium Entertainment'],
        priceText: 'Get a Quote',
        keyFeatures: 'Everything in Starter, plus:',
        checklistP: [
          '500+ Entertainment Channels',
          'Premium Sports, Viral Videos, News, Health & Wellness and Much More',
          'Interactive Social Media Wall',
          'Interactive Gaming, including Trivia and Sportsbooks',
        ],
        buttonLabel: 'Book a demo',
        icon: professionalIMG,
        disable: true,
      },
      4: {
        title: 'Branded Digital Network',
        description: [
          'Dynamic Digital Signage + Premium Entertainment + Custom Branded Elements.',
          'Recommended for 25+ Locations.',
        ],
        priceText: 'Get a Quote',
        keyFeatures: 'Everything in Professional, plus:',
        checklistP: [
          'Tailored & Branded Solutions',
          'Managed & Creative Services',
          'Personalized Implementation',
          'Custom Data Integrations',
          'Custom Support',
        ],
        buttonLabel: 'Book a demo',
        disable: false,
        icon: enterpriseIMG,
        headerStyle: 'card-header-enterprise',
        priceStyle: 'card-price-enterprise',
      },
    },
  },
};

export default FRONTCARDS;
